
import React from "react";
import { Container, Row } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer mt-5" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a  href="#!">Altbanq Lending</a>
                </li>
                <li>
                  <a   href="#!">Portal</a>
                </li>
                <li>
                  <a
                    href="#!"
                    target="_blank"
                  >
                    {`@${new Date().getFullYear()}`}
                  </a>
                </li>
              </ul>
            </nav>
           
          </Row>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
